import { Button, Modal, Table } from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { CustomCol, CustomRow } from "../../components/Custom";
import DetailTitle from "../../components/DetailTitle";
import ModalScrollContainer from "../../components/ModalScrollContainer";
import {
    fetchMerchantTransferRecordDetailsLogByIdGet,
    fetchTransferRecordLogGet
} from "../../services/transferRecordLog";
import { findDict, formatTime, moneyAddComma } from "../../utils";
const TransferRecordDetail = (props) => {
    const [ visible, setVisible ] = useState(false) // 当前组件显示状态
    const [ detailData, setDetailData ] = useState({}) // 当前组件数据
    const [ recordDetailsLogId, setRecordDetailsLogId ] = useState(null); // 当前组件的ID

    const open = (recordDetailsLogId) => {
        setVisible(true)
        setRecordDetailsLogId(recordDetailsLogId)
    }
    const close = () => {
        setVisible(false)
        setDetailData( {})
        setRecordDetailsLogId(null)
    }
    const renderFooter = () => <Button onClick={close}>关闭</Button>
    const postTransRecordGet = (data) => {
        fetchMerchantTransferRecordDetailsLogByIdGet(data).then(res => {
            setDetailData(res || {})
        })
    }


    useEffect(() => {
        recordDetailsLogId && postTransRecordGet({ recordDetailsLogId })
    },[recordDetailsLogId])
    useCallback(() => {
        props.getRef && props.getRef({open})
    },[])()
    return <Modal width={650} title="划账结算详情" visible={visible} onCancel={close} footer={renderFooter()}>
        <ModalScrollContainer>
            <div className="custom" >
                <CustomRow >
                    <CustomCol label="商户简称">
                        <span style={{ paddingLeft:6 }}>{detailData.shortName}</span>
                    </CustomCol>
                    <CustomCol label="汇集期数">
                        <span style={{ paddingLeft:6 }}>{detailData.collectionPeriod?'第'+detailData.collectionPeriod+'期':null}</span>
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="开始日期">
                        <span style={{ paddingLeft:6 }}>{detailData.startDate}</span>
                    </CustomCol>
                    <CustomCol label="结束日期">
                        <span style={{ paddingLeft:6 }}>{detailData.endDate}</span>
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="费用名称">
                        <span style={{ paddingLeft:6 }}>{detailData.cycleDetailsName}</span>
                    </CustomCol>
                    <CustomCol label="划付金额">
                        <span style={{ paddingLeft:6 }}>{detailData.transferAmount}</span>
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>

                    <CustomCol label="预交账单结清">
                        <span style={{ paddingLeft:6 }}>{detailData.advanceBillSettle?(detailData.advanceBillSettle===1?"结清":'不结清'):null}</span>
                    </CustomCol>
                    <CustomCol label="历史预交结清">
                        <span style={{ paddingLeft:6 }}>{detailData.historyAdvanceBillSettle?(detailData.historyAdvanceBillSettle===1?"结清":'不结清'):null}</span>
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="已汇集金额">
                        <span style={{ paddingLeft:6 }}>{detailData.totalAmount}</span>
                    </CustomCol>
                    <CustomCol label="已划付金额">
                        <span style={{ paddingLeft:6 }}>{detailData.transferredAmount}</span>
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="可划付金额">
                        <span style={{ paddingLeft:6 }}>{detailData.remainingAmount}</span>
                    </CustomCol>
                    <CustomCol label="所属年月">
                        <span style={{ paddingLeft:6 }}>{detailData.year}{detailData.year?'年':null}{detailData.month}{detailData.month?'月':null}</span>
                    </CustomCol>
                </CustomRow>
            </div>
        </ModalScrollContainer>
    </Modal>
}

export default TransferRecordDetail


// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/detailInfo.jsx